import env from '@src/utils/env';
import Janus from 'janus-gateway';
import adapter from 'webrtc-adapter';

let session: Janus | null = null;

const createSession = (): Promise<Janus> => {
  if (session) return Promise.resolve(session);

  return new Promise<Janus>((resolve, reject) => {
    Janus.init({
      // eslint-disable-next-line react-hooks/rules-of-hooks
      dependencies: Janus.useDefaultDependencies({ adapter }),
      callback() {
        const instance = new Janus({
          server: env.WS_MEDIA_SERVER_BASE_URI,
          token: env.WS_MEDIA_SERVER_TOKEN,
          success: () => {
            session = instance;
            resolve(instance);
          },
          error: error => {
            reject(error);
          },
          destroyed: () => {
            session = null;
          },
        });
      },
    });
  });
};

const destroySession = () => {
  // prettier-ignore
  // eslint-disable-next-line no-empty
  try { session?.destroy({}) } catch {}
  session = null;
};

export { createSession, destroySession };
